

export default (state = [], action) => {
  if (action.type == "SET_CHIOURIM") {
    return action.value;
  }
  return state;
};